import React from "react";

import {makeStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(() => ({
  header: {
    fontSize: 24,
    fontFamily: "Roboto-Bold",
  }
}))

const ConfirmationHeader = ({stepName}) => {
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12} className={classes.header}>
        Orderübersicht
      </Grid>
      <Grid item xs={12}>
        Prüfen Sie die vorgesehenen Anlagen, Zahlpläne sowie Kosten und Konditionen.
      </Grid>
      {!!stepName && (
        <Grid item xs={12} className={classes.header}>{stepName}</Grid>
      )}
    </>
  )
}

export default ConfirmationHeader;